import { layoutReducer } from 'stores/layout';

import { configureStore } from '@reduxjs/toolkit';

export default configureStore({
  reducer: { layoutReducer: layoutReducer }
});
